import React, { useEffect, useState } from "react";
import { Modal, Spinner, Alert } from "react-bootstrap";
import axios from "axios";

const DeliverySignatureModal = ({ show, onHide, deliveryNo }) => {
  const [loading, setLoading] = useState(false);
  const [signature, setSignature] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show && deliveryNo) {
      fetchSignature();
    }
  }, [show, deliveryNo]);

  const fetchSignature = async () => {
    setLoading(true);
    setError(null);
    setSignature(null);

    try {
      const tokenStr = localStorage.getItem("accessToken");

      const { data } = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/orders/get-delivery-signature/${deliveryNo}`,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`
          }
        }
      );
      setSignature(data?.signature);

    } catch (err) {
      console.error(err);
      setError("Unable to load signature.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSignature(null);
    setError(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Delivery Signature</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">

        {loading && (
          <div className="py-4">
            <Spinner animation="border" />
            <div className="mt-2 text-muted">Loading signature...</div>
          </div>
        )}

        {error && <Alert variant="danger">{error}</Alert>}

        {!loading && !error && signature && (
          <div>
            <img
              src={`data:image/png;base64,${signature}`}
              alt="Delivery Signature"
              style={{
                maxWidth: "100%",
                border: "1px solid #dee2e6",
                borderRadius: "6px",
                padding: "8px",
                background: "#fff"
              }}
            />
          </div>
        )}

        {!loading && !error && !signature && (
          <div className="text-muted">No signature available.</div>
        )}

      </Modal.Body>
    </Modal>
  );
};

export default DeliverySignatureModal;
